<template>
    <div
        class="h-100"
        :class="moduleClasses">
        <div :class="cardClasses">
            <div class="row flex-sm-nowrap h-100 no-gutters m-0">
                <div class="col-auto col-sm-4 col-lg-5 col-xl-4 col-xxl-3"
                    v-if="showImageModule">
                    <img
                        loading="lazy"
                        class="card-img"
                        :src="module.image"
                        :alt="moduleName">
                </div>
                <div class="col-12" :class="[showImageModule ? 'col-sm-8 col-lg-7 col-xl-8 col-xxl-9' : '']">
                    <div class="card-block d-flex flex-column h-100"
                        :class="[{'px-3 pt-3': (showImageModule)},
                                    (showImageModule ? (enableNotificationsArrow ? 'pb-2' : 'pb-3') : '')]">
                        <div class="card-header p-0 bg-transparent border-0">
                            <div class="media" :class="showImageModule ? 'd-block' : 'flex-row flex-nowrap'">
                                <img
                                    v-if="showIconModule"
                                    loading="lazy"
                                    class="align-self-center mr-3"
                                    :src="module.icon"
                                    :alt="moduleName">
                                <!-- <div class="media-body align-self-center">
                                    <div class="row">
                                        <div class="col-12 text-truncate">
                                            <template v-if="module.route">
                                                <router-link class="" :to="{ name: module.route }" :title="title">
                                                    {{ module.name }}
                                                </router-link>
                                            </template>
                                            <template v-else-if="module.url">
                                                <a class="" :href="module.url" target="_blank" :title="title">
                                                    {{ module.name }}
                                                </a>
                                            </template>
                                            <template v-else>
                                                {{ module.name }}
                                            </template>
                                        </div>
                                    </div>
                                </div> -->
                                <div class="title">
                                    {{ moduleName }}
                                </div>
                            </div>
                        </div>

                        <div class="card-body p-0">
                            <p class="card-text block-with-text">{{ module.description }}</p>
                        </div>
                        <div class="card-footer p-0 bg-transparent border-0">
                            <nav class="navbar navbar-white navbar-light p-0" v-if="notifications || enableNotificationsArrow">
                                <ul class="navbar-nav w-100">
                                    <li class="nav-item">
                                        <a
                                            href="#"
                                            class="nav-link d-flex flex-nowrap justify-content-between py-1"
                                            :class="{'has-notification': notifications.num > 0}"
                                            >
                                            <div class="d-flex">
                                                <div class="pr-2" v-if="enableNotificationsIcon">
                                                    <i class="far fa-bell"></i>
                                                    <span class="badge badge-danger navbar-badge"></span>
                                                </div>
                                                <span class="card-text">{{ notifications.text }}</span>
                                            </div>
                                            <div class="text-right" v-if="enableNotificationsArrow">
                                                <img loading="lazy"
                                                    :src="notificationImage"
                                                    :alt="notificationImageAlternateText">
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GlobalMixin from '@/app/shared/mixins/global';

export default {
    mixins: [
        GlobalMixin
    ],
    props: {
        module: {
            type: Object,
            default: null,
            require: true
        },
        config: {
            type: Object,
            default: ()=>{},
        },
        listClass: {
            type: String,
            default: '', //'col-12 col-sm-6',
        },
        showImage: {
            type: Boolean,
            default: true,
        },
        showIcon: {
            type: Boolean,
            default: true,
        },
        showNotifications: {
            type: Boolean,
            default: true,
        },
        showNotificationsIcon: {
            type: Boolean,
            default: true,
        },
        showNotificationsArrow: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
        }
    },
    computed: {
        moduleClasses() {
            return [
                this.listClass,
                {
                    'fixed-height': this.showImageModule
                }
            ];
        },
        cardClasses() {
            return [
                'card module h-100',
                {
                    'no-active': !this.module.active,
                    'p-3 p-md-4': !this.showImageModule
                },
            ];
        },
        moduleName() {
            return this.module.name;
        },
        url() {
            return this.module.url;
        },
        route() {
            return this.module.route;
        },
        enableImage() {
            return this.showImage && (this.config.showImage != undefined ? this.config.showImage : this.showImage);
        },
        showImageModule() {
            return this.enableImage && this.module.image;
        },
        enableIcon() {
            return this.config.showIcon != undefined ? this.config.showIcon : this.showIcon;
        },
        showIconModule() {
            return this.enableIcon && this.module.icon;
        },
        notifications() {
            return this.module.notifications || {};
        },
        enableNotifications() {
            return this.showNotifications && (this.config.showNotifications != undefined ? this.config.showNotifications : this.showNotifications);
        },
        enableNotificationsIcon() {
            return this.showNotificationsIcon && (this.config.showNotificationsIcon != undefined ? this.config.showNotificationsIcon : this.showNotificationsIcon);
        },
        enableNotificationsArrow() {
            return this.showNotificationsArrow && (this.config.showNotificationsArrow != undefined ? this.config.showNotificationsArrow : this.showNotificationsArrow);
        },
        notificationImage: function() {
            return this.assetsPathTheme('/icons/arrow-forward.svg');
        },
        notificationImageAlternateText: function() {
            return 'Visualizar';
        },
    },
    methods: {
        processNotification: function(num) {
            return num>0?`Tem ${num} notificações`:'Não tem notificações';
        },
    }
}
</script>